import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import ExpanseHeadsDrawer from "./ExpanseHeadsDrawer";
import API from "../../../api";
import CustomTable from "../../../components/Table/CustomTable";
import ConfirmationModal from "../../../components/ConfirmationModal";
import { getUserRole } from "../../../utils/auth";


const ExpanseHeads = () => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const [expanseHeads, setExpanseHeads] = useState([]);
    const [selectedExpanseHead, setSelectedExpanseHead] = useState(null);
    const [taxToDelete, setExpanseHeadToDelete] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [paginationInfo, setPaginationInfo] = useState({
        current: 1,
        pageSize: 20,
        total: 0,
    });
    const [userRole, setUserRole] = useState("");


    useEffect(() => {
        setUserRole(getUserRole());
    }, []);

    const getExpanseHeads = async () => {
        const { current, pageSize } = paginationInfo;
        try {
            setLoading(true)
            const response = await API.get(
                `/expanse-heads/paginate?page=${current}&limit=${pageSize}`
            );
            const { expanseHeads: expanseHeads, pagination } = response?.data || {};
            setExpanseHeads(expanseHeads || []);
            setPaginationInfo((prev) => ({
                ...prev,
                total: pagination?.total || 0,
            }));
        } catch (err) {
            console.error(err);
            message.error("Failed to fetch expanseHeads. Please try again.");
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        getExpanseHeads();
    }, [paginationInfo.current, paginationInfo.pageSize]);

    const handleDeleteClick = (tax) => {
        setExpanseHeadToDelete(tax);
        setIsDeleteModalVisible(true);
    };

    const handleDeleteExpanseHead = async () => {
        try {
            await API.delete(`/expanse-heads/${taxToDelete?._id}`);
            message.success("ExpanseHead deleted successfully!");
            getExpanseHeads();
        } catch (err) {
            console.error("Error deleting tax:", err);
            message.error("Failed to delete tax.");
        } finally {
            setIsDeleteModalVisible(false);
        }
    };

    const handleAddExpanseHead = async (newExpanseHead) => {
        try {
            await API.post("/expanse-heads", newExpanseHead);
            message.success("ExpanseHead added successfully!");
            getExpanseHeads();
        } catch (err) {
            console.error(err);
            message.error("Failed to add tax.");
        }
    };

    const handleEditExpanseHead = async (updatedExpanseHead) => {
        try {
            await API.put(`/expanse-heads/${updatedExpanseHead?._id}`, updatedExpanseHead);
            message.success("ExpanseHead updated successfully!");
            getExpanseHeads();
            setOpenDrawer(false);
        } catch (err) {
            console.error(err);
            message.error("Failed to update tax.");
        }
    };

    const columns = [
        {
            title: "Index",
            key: "index",
            render: (_, __, index) =>
                (paginationInfo.current - 1) * paginationInfo.pageSize + index + 1,
        },
        {
            title: "ExpenseHead Name",
            dataIndex: "name",
            key: "name",
        },
        userRole.editPermission == true && {

            title: "Actions",
            key: "actions",
            align: "center",
            render: (record) => (
                <div>
                    <Button
                        icon={<EditOutlined />}
                        onClick={() => {
                            setIsEdit(true);
                            setSelectedExpanseHead(record);
                            setOpenDrawer(true);
                        }}
                    />
                    {/* <Button
                        danger
                        icon={<DeleteOutlined />}
                        style={{ marginLeft: 8 }}
                        onClick={() => handleDeleteClick(record)}
                    /> */}
                </div>
            ),
        },
    ];

    const handlePaginationChange = (current, pageSize) => {
        setPaginationInfo((prev) => ({
            ...prev,
            current: current,
            pageSize: pageSize,
        }));
    };

    return (
        <div style={{
            padding: "20px",
            background: "#fff",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
        }}>
            <div style={{ marginBottom: 16 }}>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                        setIsEdit(false);
                        setSelectedExpanseHead(null);
                        setOpenDrawer(true);
                    }}
                >
                    Add New ExpanseHead
                </Button>
            </div>

            <CustomTable
                columns={columns}
                dataSource={expanseHeads}  // Use filtered data here
                onPaginationChange={(pagination) =>
                    setPaginationInfo({ current: pagination.current, pageSize: pagination.pageSize })
                }
                loading={loading}
                style={{ padding: '0 20px' }}
                total={paginationInfo.total}
            />

            <ExpanseHeadsDrawer
                open={openDrawer}
                setOpen={setOpenDrawer}
                data={selectedExpanseHead}
                isEdit={isEdit}
                onSubmit={isEdit ? handleEditExpanseHead : handleAddExpanseHead}
            />

            <ConfirmationModal
                visible={isDeleteModalVisible}
                onConfirm={handleDeleteExpanseHead}
                onCancel={() => setIsDeleteModalVisible(false)}
                title="Confirm Deletion"
                content="Are you sure you want to delete this tax? This action cannot be undone."
            />
        </div>
    );
};

export default ExpanseHeads;
